<div class="security-settings-container">
  <!-- Security Actions Card -->
  <div class="card mb-4">
    <div class="card-header">
      <h3>{{ 'users.securitySettings.title' | translate }}</h3>
      <p class="text-muted">
        {{ 'users.securitySettings.subtitle' | translate }}
      </p>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="security-action-card">
            <div class="icon-container bg-primary">
              <i class="bi bi-shield-lock"></i>
            </div>
            <div class="content">
              <h5>{{ 'users.activeSessions.title' | translate }}</h5>
              <p class="text-muted">
                {{ 'users.securitySettings.viewDevices' | translate }}
              </p>
              <a routerLink="/active-sessions" class="btn btn-sm btn-outline-primary">
                {{ 'users.securitySettings.manageSessions' | translate }}
                <i class="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="security-action-card">
            <div class="icon-container bg-danger">
              <i class="bi bi-box-arrow-right"></i>
            </div>
            <div class="content">
              <h5>{{ 'users.securitySettings.logoutAllDevices' | translate }}</h5>
              <p class="text-muted">
                {{ 'users.securitySettings.logoutAllDevicesDesc' | translate }}
              </p>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="logoutFromAllDevices()"
                [disabled]="loggingOutAll"
              >
                <span *ngIf="!loggingOutAll">
                  {{ 'users.securitySettings.logoutAll' | translate }}
                  <i class="bi bi-box-arrow-right"></i>
                </span>
                <span *ngIf="loggingOutAll">
                  <span class="spinner-border spinner-border-sm" role="status"></span>
                  {{ 'users.securitySettings.loggingOut' | translate }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Authentication History Card -->
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div>
        <h3>{{ 'users.securitySettings.authHistoryTitle' | translate }}</h3>
        <p class="text-muted mb-0">
          {{ 'users.securitySettings.authHistoryDesc' | translate }}
        </p>
      </div>

      <div class="btn-group">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          [class.active]="historyDays === 7"
          (click)="changeHistoryRange(7)"
        >
          {{ 'users.securitySettings.days7' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          [class.active]="historyDays === 30"
          (click)="changeHistoryRange(30)"
        >
          {{ 'users.securitySettings.days30' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          [class.active]="historyDays === 90"
          (click)="changeHistoryRange(90)"
        >
          {{ 'users.securitySettings.days90' | translate }}
        </button>
      </div>
    </div>

    <div class="card-body">
      <!-- Loading state -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'users.activeSessions.loading' | translate }}</span>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loading && authHistory.length === 0" class="empty-state text-center py-5">
        <i class="bi bi-clock-history" style="font-size: 3rem; color: #6c757d;"></i>
        <p class="mt-3">{{ 'users.securitySettings.emptyHistory' | translate }}</p>
      </div>

      <!-- History timeline -->
      <div *ngIf="!loading && authHistory.length > 0" class="auth-timeline">
        <div
          *ngFor="let event of authHistory; let i = index"
          class="timeline-item"
          [class.failed]="!event.success"
        >
          <div class="timeline-marker" [class]="'bg-' + getEventColor(event)">
            <i class="bi bi-{{ getEventIcon(event.eventType) }}"></i>
          </div>

          <div class="timeline-content">
            <div class="timeline-header">
              <h6 class="mb-1">
                {{ getEventTitle(event) }}
                <span *ngIf="!event.success" class="badge bg-danger ms-2">
                  {{ 'users.securitySettings.failed' | translate }}
                </span>
              </h6>
              <small class="text-muted">{{ formatDate(event.timestamp) }}</small>
            </div>

            <div class="timeline-details">
              <div *ngIf="event.ipAddress" class="detail-row">
                <i class="bi bi-geo-alt"></i>
                <span>{{ event.ipAddress }}</span>
                <span *ngIf="event.location"> - {{ event.location }}</span>
              </div>

              <div *ngIf="event.userAgent" class="detail-row">
                <i class="bi bi-laptop"></i>
                <span class="text-truncate">{{ event.userAgent }}</span>
              </div>

              <div *ngIf="event.errorMessage" class="detail-row text-danger">
                <i class="bi bi-exclamation-circle"></i>
                <span>{{ event.errorMessage }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Security Tips Card -->
  <div class="card mt-4">
    <div class="card-body">
      <h5 class="card-title">
        <i class="bi bi-lightbulb text-warning"></i>
        {{ 'users.securitySettings.tipsTitle' | translate }}
      </h5>
      <ul class="small text-muted mb-0">
        <li>{{ 'users.securitySettings.tip1' | translate }}</li>
        <li>{{ 'users.securitySettings.tip2' | translate }}</li>
        <li>{{ 'users.securitySettings.tip3' | translate }}</li>
        <li>{{ 'users.securitySettings.tip4' | translate }}</li>
        <li>{{ 'users.securitySettings.tip5' | translate }}</li>
      </ul>
    </div>
  </div>
</div>
